import type { DesignVariant, Project } from "./types";

const PROJECT_KEY = "prostorai:project";
const VARIANTS_KEY = "prostorai:variants";

export function saveProject(project: Project): void {
  localStorage.setItem(PROJECT_KEY, JSON.stringify(project));
}

export function loadProject(id?: string): Project | null {
  const raw = localStorage.getItem(PROJECT_KEY);
  if (!raw) return null;
  try {
    const project = JSON.parse(raw) as Project;
    if (id && project.id !== id) return null;
    return project;
  } catch {
    return null;
  }
}

export function saveVariants(variants: DesignVariant[]): void {
  localStorage.setItem(VARIANTS_KEY, JSON.stringify(variants));
}

export function loadVariants(projectId: string): DesignVariant[] {
  const raw = localStorage.getItem(VARIANTS_KEY);
  if (!raw) return [];
  try {
    return (JSON.parse(raw) as DesignVariant[]).filter((variant) => variant.projectId === projectId);
  } catch {
    return [];
  }
}

export function deleteProject(): void {
  localStorage.removeItem(PROJECT_KEY);
  localStorage.removeItem(VARIANTS_KEY);
}
